import { ItemsActionTypes, ItemsActions, Comment } from './types';

interface ItemsState {
  mapItems: GeoJSON.FeatureCollection<GeoJSON.Geometry>;
  mapItem: any;
  mapItemDetails: any;
  uploaded?: boolean;
  preImageGeoData?: {
    latitude: Number[];
    longitude: Number[];
  };
  comments: Comment[];
  commentLikes: {
    [commentId: string]: {
      count: number;
      userLiked: boolean;
    };
  };
  isLoading: boolean;
}

const initialState: ItemsState = {
  mapItems: { type: 'FeatureCollection', features: [] },
  mapItem: null,
  mapItemDetails: null,
  comments: [],
  commentLikes: {},
  isLoading: false
};
export default function mapItemsReducer(state = initialState, action: ItemsActions): ItemsState {
  switch (action.type) {
    case ItemsActionTypes.GET_MAP_ITEMS_SUCCESS:
      return {
        ...state,
        mapItems: action.payload.mapItems,
      };
    case ItemsActionTypes.GET_MAP_ITEM_SUCCESS:
      return {
        ...state,
        mapItem: action.payload.mapItem,
      };
    case ItemsActionTypes.GET_MAP_ITEM_DETAILS_SUCCESS:
      return {
        ...state,
        mapItemDetails: action.payload.mapItemDetails,
      };
    case ItemsActionTypes.GET_IMAGE_LOCATION_SUCCESS:
      return {
        ...state,
        ...action.payload,
      };
    case ItemsActionTypes.DELETE_MAP_ITEM_SUCCESS:
      return {
        ...state,
      };
    case ItemsActionTypes.EDIT_MAP_ITEM_SUCCESS:
      return {
        ...state,
      };
    case ItemsActionTypes.CLEAR_MAP_ITEM_ERROR:
      return {
        ...state,
      };
    case ItemsActionTypes.CLEAR_MAP_ITEM_DETAILS:
      return {
        ...state,
        mapItemDetails: null,
      };
    case ItemsActionTypes.GET_COMMENTS_SUCCESS:
      return {
        ...state,
        comments: action.payload.comments,
      };
    case ItemsActionTypes.ADD_COMMENT_LOADING:
      return {
        ...state,
        isLoading: true,
      };
    case ItemsActionTypes.ADD_COMMENT_FAIL:
      return {
        ...state,
        isLoading: false,
      };
    case ItemsActionTypes.ADD_COMMENT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        comments: [...state.comments, action.payload.comment],
      };
    case ItemsActionTypes.GET_LIKES_SUCCESS:
      return {
        ...state,
        commentLikes: {
          ...state.commentLikes,
          [action.payload.commentId]: {
            count: action.payload.likesCount,
            userLiked: action.payload.userLiked,
          },
        },
      };
    case ItemsActionTypes.TOGGLE_LIKE_SUCCESS:
      return {
        ...state,
        commentLikes: {
          ...state.commentLikes,
          [action.payload.commentId]: {
            count: action.payload.likesCount,
            userLiked: action.payload.liked,
          },
        },
      };
    default:
      return state;
  }
}
